import {CustomMaterialType} from './custom-material-type.enum';
import {ResourceManagerService} from '../resource.manager.service';
import {EnvironmentService} from '../environment.service';
import {Material} from 'three';

/**
 * MaterialRegistry pitää kirjaa kaikista rekisteröidyistä materiaaliluokista.
 */
export class MaterialRegistry {
    private static registry = new Map<
        CustomMaterialType,
        new (resourceManager: ResourceManagerService, environmentService: EnvironmentService) => MaterialFactory<Material>
    >();

    static registerMaterial<T extends Material>(
        type: CustomMaterialType,
        materialClass: new (resourceManager: ResourceManagerService, environmentService: EnvironmentService) => MaterialFactory<T>
    ): void {
        console.log(`🔹 Registering material: ${type}`);
        this.registry.set(type, materialClass);
    }

    static createMaterial<T extends Material>(
        type: CustomMaterialType,
        resourceManager: ResourceManagerService,
        environmentService: EnvironmentService
    ): Promise<T> {
        console.log(`🔍 Looking for material: ${type}`);
        console.log("🗂️ Current registered materials:", this.registry);

        const MaterialClass = this.registry.get(type);

        if (!MaterialClass) {
            return Promise.reject(
                new Error(`❌ No material registered for type: ${type}`)
            );
        }

        const materialInstance = new MaterialClass(resourceManager, environmentService);
        return materialInstance.create() as Promise<T>;
    }

    /**
     * 🔥 Dynaaminen rekisteröinti: Lataa ja rekisteröi kaikki materiaaliluokat.
     */
    static async autoRegisterMaterials(): Promise<void> {
        //console.log("🔄 Auto-registering materials...");

        const materialModules = [
            import('./custom-materials/anodized-aluminum-material'),
            import('./custom-materials/powder-coated-material'),
            //import('./custom-materials/galvanized-steel-material')
        ];

        await Promise.all(materialModules)
            .then(() => {
                //console.log("✅ Auto-registration complete!")
            })
            .catch(err => console.error("❌ Error auto-registering materials:", err));
    }
}



/**
 * Kaikkien materiaaliluokkien tulee toteuttaa tämä rajapinta.
 */
export interface MaterialFactory<T extends Material = Material> {
    create(): Promise<T>;
}
